import { render, staticRenderFns } from "./MediaTagHandlingExistingTags.vue?vue&type=template&id=5e023518&scoped=true&"
import script from "./MediaTagHandlingExistingTags.vue?vue&type=script&lang=js&"
export * from "./MediaTagHandlingExistingTags.vue?vue&type=script&lang=js&"
import style0 from "./MediaTagHandlingExistingTags.vue?vue&type=style&index=0&id=5e023518&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e023518",
  null
  
)

export default component.exports